import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=0c5df0e2&"
import script from "./PaginationBar.vue?vue&type=script&lang=js&"
export * from "./PaginationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports